module.exports = __webpack_public_path__ + "static/img/bord_majesteit_2.ae42d03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bord_majesteit_2.jpg
// module id = /xc6
// module chunks = 0